const labelWithAddOnsStyle = theme => ({
    container: { },
    spacing: { marginLeft: theme.spacing(1) },
    label: { },
    clickable: { cursor: 'pointer' },
});
export default labelWithAddOnsStyle;
